import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9c5267f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=9c5267f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5267f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c5267f2')) {
      api.createRecord('9c5267f2', component.options)
    } else {
      api.reload('9c5267f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9c5267f2&scoped=true&", function () {
      api.rerender('9c5267f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/LanguageSet/index.vue"
export default component.exports